import { Injectable } from '@angular/core';
import { HttpApiService } from '../services/http-api.service';
import { Pagination } from '../utils/interfaces/pagination';

@Injectable({
  providedIn: 'root',
})
export class SubAccountAgentService {
  constructor(private http: HttpApiService) {}

  getAgentSubPagination(param: any) {
    return this.http.get<Pagination<AgentSub[]>>(`api/v2/agent-sub/get/pagination`, {
      params: param,
    });
  }
  getRolesForAgentSub() {
    return this.http.get(`api/v2/agent-sub/get/roles`);
  }
  getAgentSubById(adminId: number) {
    return this.http.get<AgentSub>(`api/v2/agent-sub/get/admin-by-id?admin_id=${adminId}`);
  }
  createAgentSub(value: ICUAgentSub) {
    return this.http.post<ICUAgentSub>(`api/v2/agent-sub/create`, value);
  }
  editAgentSub(value: ICUAgentSub, adminId: number) {
    return this.http.put<ICUAgentSub>(`api/v2/agent-sub/update?admin_id=${adminId}`, value);
  }
  resetPasswordAgentSub(new_password: string, adminId: number) {
    return this.http.put<ICUAgentSub>(
      `api/v2/agent-sub/update/reset-password?admin_id=${adminId}`,
      {
        new_password: new_password,
      }
    );
  }
  changeStatusAgentSub(new_status: string, adminId: number) {
    return this.http.put<ICUAgentSub>(`api/v2/agent-sub/update/change-status?admin_id=${adminId}`, {
      new_status: new_status,
    });
  }
  removeAgentSub(adminId: number) {
    return this.http.delete<ICUAgentSub>(`api/v2/agent-sub/remove?admin_id=${adminId}`);
  }
}

export interface ICUAgentSub {
  username: string;
  password: string;
  name: string;
  image: string;
  status: string;
  roles: string[];
  // -- เปิด 2FA ให้บัญชีนี้ (ผูกอุปกรณ์ตอน login ครั้งแรก)
  using_2fa?: boolean;
  // -- ผูกอุปกรณ์แล้ว (อ่านอย่างเดียว)
  two_factor?: boolean;
}

export interface IRolesSubAccount {
  roleId: number;
  roleName: string;
  roleDetail: string;

  _checked?: boolean;
}

export interface AgentSub {
  id: number;
  username: string;
  name: string;
  image: string;
  status: string;
  agent_id: number;
  roles: string;
  is_main: boolean;
  update_dt: null;
  create_dt: null | string;
  agent_code: string;
  agent_name: string;

  _deleting?: boolean;
}
